/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ApplicationState        from 'g3w-state';
import GUI                     from 'g3w-app';
import { getCatalogLayerById } from 'utils/getCatalogLayerById';
import { XHR }                 from 'utils/XHR';

function _setAllLayersVisible(layers) {
  layers.nodes.forEach(n => {
    if (undefined === n.id) {
      _setAllLayersVisible({ nodes: n.nodes, visible: layers.visible && n.checked });
    } else if (n.parentGroup.checked && n.checked) {
      getCatalogLayerById(n.id).setVisible(layers.visible);
    }
  });
};

const __vue_script__ = {

  /** @since 3.8.6 */
  name: 'catalog-tree',

  props : [
    'layerstree',
    'storeid',
    'legend',
    'legendplace',
    'parent_mutually_exclusive',
    'externallayers',
    'root',
    'parent'
  ],

  data() {
    return {
      expanded:          this.layerstree.expanded,
      logged:            undefined !== ApplicationState.user.id, //@since 3.10.0
      /** @since 3.8.0 - Whether to show loading bar while changing style categories */
      loading_legend:    false,
      /** Array of categories */
      legend_categories: [],
      /** @since 3.8.0 - Holds a reference to current layer style (active category) */
      currentstyle:      null,
    }
  },

  computed: {

    /**
     * @returns {boolean} whether to display total number of features for current layer
     *
     * @since 3.8.0
     */
    has_feature_count() {
      return undefined !== this.layerstree.featurecount;
    },

    has_legend() {
      return !this.isGroup && !this.layerstree.exclude_from_legend && this.layerstree.geolayer;
    },

    isGroup() {
      return !!this.layerstree.nodes;
    },

    isTable() {
      return !this.isGroup && !this.layerstree.geolayer && !this.layerstree.external;
    },

    legend_position() {
      return (!this.layerstree.exclude_from_legend && this.layerstree.legend) ? this.legendplace : 'tab';
    },

    has_scale_visibility_toolip() {
      return !this.isGroup && this.layerstree.scalebasedvisibility && this.layerstree.disabled && this.layerstree.checked;
    },

    isHidden() {
      return true === this.layerstree?.hidden;
    },

    selected() {
      this.layerstree.selected = (this.layerstree.disabled && this.layerstree.selected) ? false : this.layerstree.selected;
    },

    isDisabled() {
      return !this.isGroup && !this.isTable && !this.layerstree.checked && (!this.layerstree.visible || this.layerstree.disabled);
    },

    /**
     * @since 3.8.0
     */
    getFeatureCount() {
      return Object.values(this.layerstree.featurecount).reduce((total, categoryFeatureCount) => total + 1 * categoryFeatureCount, 0);
    },

    /**
     * @returns {boolean} whether is a WMS layer
     * 
     * @since 4.1.0
     */
    is_external_wms() {
      return 'wms' === this.layerstree.source.type;
    },

    /**
     * @returns {boolean} whether layer has legend to show
     * 
     * @since 4.1.0
     */
    legend_tree() {
      return this.layerstree.legend || {};
    },

    /**
     * @returns {boolean} whether to show legend
     * 
     * @since 4.1.0
     */
    show_legend() {
      return (
        this.layerstree.expanded 
        && this.layerstree.visible 
        && ('toc' === this.legendplace || 'tab' === this.legendplace && this.layerstree.categories)
      );
    },

  },

  watch: {

    'layerstree.checked'() {
      if (this.isGroup) {
        this.onGroupChecked(this.layerstree);
      } else {
        this.onLayerChecked(this.layerstree);
      }
      //@since 4.0.7 In case of map theme change and layers tree is not root, reset map theme
      if (!this.layerstree.root && !ApplicationState.map_theme.change) {
        ApplicationState.map_theme.theme = null; // @since 4.0.7 on group or layer change , set map_theme null
      }
    },

    /**
     * @since 4.1.0
     */
    has_legend: {
      immediate: true,
      async handler(show) {
        if (show) {
          this.loading_legend    = false;
          this.legend_categories = [];
          this.currentstyle      = this.layerstree.styles.find(s => true === s.current)?.name;

          /**
           * Used to check if layer and its legend categories are initialized
           * That means register all events at first time the layer is visible
           * without do any server request
           *
           * @type {boolean}
           *
           * @since 3.8.0
           */
          this.initialize = false;

          /**
           * @FIXME the following comment seems wrong (isn't `this.dynamic` a `boolean` variable?)
           *
           * Store legend url icons based on the current style of layer.
           * It uses to cache all symbols of a style without get a new request to server
           *
           * @type {{}}
           */
          this.dynamic  = ApplicationState.project.state.context_base_legend;

          this.mapReady = false;

          // listen to layer change style event
          getCatalogLayerById(this.layerstree.id).onafter('change', this.onLayerChange);

          // Get all legend graphics of a layer when start (exclude wms source)
          if (!this.is_external_wms && true === this.layerstree.visible) {
            await this.initLegend();
          }

          if (this.layerstree.visible && this.is_external_wms) {
            await this.setWmsSourceLayerLegendUrl();
          }
        } else {
          //remove change event on legend
          getCatalogLayerById(this.layerstree.id)?.un('change', this.onLayerChange);
        }
      }
    },

    /**
     * Only when visible show categories layer. In case of dynamic legend check
     *
     * @param {boolean} visible
     * 
     * @since 4.1.0
     */
    async 'layerstree.visible'(visible) {
      if (!this.has_legend) {
        return;
      }
      // check if layer is enabled to get legend and if is visible
      const enabled = visible && !this.is_external_wms;
      // initialize if it is the first time that is visible.
      if (enabled && false === this.initialize) {
        await this.initLegend();
      }
      // otherwise show categories base on if is dynamic legend or not
      if (enabled && false !== this.initialize) {
        await this.setCategories(!this.dynamic);
      }
      if (visible && this.is_external_wms) {
        await this.setWmsSourceLayerLegendUrl();
      }
    },

  },

  methods: {

    /**
     * Remove current active filter
     *
     * @since 3.9.0
     */
    removeFilter() {
      return getCatalogLayerById(this.layerstree.id).deleteToken();
    },

    /**
     * Handle change checked property of group
     *
     * @param {boolean} group.checked
     * @param {uknown}  group.parentGroup
     * @param {uknown}  group.nodes
     */
    onGroupChecked(group) {

      if (!group.checked) {
        group.nodes.forEach(n => {
          if (undefined === n.id) {
            _setAllLayersVisible({ nodes: n.nodes, visible: false });
          } else if (n.checked) {
            getCatalogLayerById(n.id).setVisible(false);
          }
        });
        return; // NB exit early!
      }

      const visible            = group?.parentGroup?.checked ?? true;
      const mutually_exclusive = group?.parentGroup?.mutually_exclusive;

      if (!mutually_exclusive) {
        _setAllLayersVisible({ nodes: group.nodes, visible });
      }

      if (mutually_exclusive) {
        group.parentGroup.nodes.forEach(n => {
          n.checked = n.groupId === group.groupId;
          if (n.checked) {
            _setAllLayersVisible({ nodes: n.nodes, visible });
          }
        });
      }

      // traverse parent groups
      let g = group.parentGroup;
      while (g) {
        g.checked = g.root || g.checked;
        g         = g.parentGroup;
      }
    },

    /**
     * Handle visibilty change (layer.checked property)
     *
     * @param {boolean} layer.checked
     * @param {string}  layer.id
     * @param {boolean} layer.disabled
     * @param {boolean} layer.projectLayer
     * @param {uknown}  layer.parentGroup
     */
    onLayerChecked(layer) {

      // external layer (eg. temporary layer through `addlayerscontrol`)
      if (!layer.projectLayer) {
        layer.visible = layer.checked;
        layer.setVisible(layer.checked);
        return;  // NB exit early!
      }

      // project layer (eg. qgis layer)
      const qlayer  = getCatalogLayerById(layer.id);
      const checked = layer.checked;

      qlayer.setVisible(checked ? !layer.disabled : false)

      if (checked && layer.parentGroup?.mutually_exclusive) {
        layer.parentGroup.nodes.forEach(n => n.checked = n.id === layer.id);
      }

      // traverse parent groups
      let g = layer.parentGroup;
      while (checked && g) {
        g.checked = true;
        g         = g.parentGroup;
      }
    },

    /**
     * Save layer filter
     *
     * @since 3.9.0
     */
    saveFilter(layerstree) {
      getCatalogLayerById(layerstree.id).saveFilter();
    },

    async toggleFilter() {
      this.layerstree.filter.active = await ApplicationState.layers[this.storeid].getLayerById(this.layerstree.id).toggleToken();
    },

    /**
     * Remove layer from queryresults selection
     */
    async clearSelection() {
      const storeid = this.storeid;
      const layer = this.layerstree;

      if (!layer) {
        return console.warn('undefined layer');
      }

      const action = layer.external && GUI.getActionLayerById({ layer, id: 'selection' });

      // PROJECT LAYER
      if (!layer.external && storeid) {
        await ApplicationState.layers[storeid].getLayerById(layer.id).clearSelectionFids();
      }

      // EXTERNAL LAYER
      if (layer.external) {
        layer.selection.active = false;
        layer.selection.features.forEach((feature, i) => {
          // skip when ..
          if (!feature.selected) {
            return;
          }
          feature.selected = false;
          if (action) {
            action.state.toggled[i] = false;
          }
          GUI.defaultsLayers.selectionLayer.getSource().removeFeature(feature);
        });
      }
      //@since 4.0.4 Need to set to false eventually features of layer in queryresults service
      if (!layer.external) {
        (GUI.state.queried_layers.find(l => layer.id === l.id)?.features || []).forEach(f => f.selected = false);
      }
    },

    toggle() {
      this.layerstree.checked = !this.layerstree.checked;
      //@since 4.1.0 Emite layer checked event
      this.$emit('layerchecked', this.layerstree);
    },

    expandCollapse() {
      this.layerstree.expanded = !this.layerstree.expanded;
    },

    /**
     * Select legend item
     */
    select() {
      // `undefined === selected` means unselectable layer (eg. external/temporary  WMS)
      if (
        undefined !== this.layerstree.selected 
        && ((!this.isGroup && !this.isTable) || (this.layerstree.external && false === this.layerstree.projectLayer))
      ) {
        GUI.selectLayer(this.layerstree.id);
      }
    },

    /**
     * @TODO refactor this, almost the Same as `ContextMenu.vue::zoomToLayer(layer)`
     *
     * @since 3.10.0
     */
    maybeZoomToLayer(layer) {
      if (this.canZoom(this.layerstree)) {
        let bbox = [layer.bbox.minx, layer.bbox.miny, layer.bbox.maxx, layer.bbox.maxy];
        let epsg = layer.epsg || GUI.getEpsg();
        bbox = epsg === GUI.getEpsg() ? bbox : ol.proj.transformExtent(bbox, epsg, GUI.getEpsg());
        const geometry = ol.extent.containsExtent(ApplicationState.project.state.extent, bbox) ? bbox : ApplicationState.project.state.extent;
        const view     = GUI.getMap().getView();
        view.animate(
          { duration: 200, center:     view.getCenter() },
          { duration: 200, resolution: view.getResolution() }
        );
        view.fit(geometry, { constrainResolution: true, size: GUI.getMap().getSize() });
      }
    },

    /**
     * @TODO refactor this, almost the same as: `ContextMenu.vue::canZoom(layer))`
     *
     * @since v3.8
     */
    canZoom(layer) {
      return (layer.bbox && [layer.bbox.minx, layer.bbox.miny, layer.bbox.maxx, layer.bbox.maxy].find(c => c > 0));
    },

    /**
     * Handle `click` and `doubleclick` click events on a single tree item (TOC).
     *
     * 1 = select legend item
     * 2 = zoom to layer bounds
     *
     * @since v3.8
     */
    onTreeItemClick() {
      this.CLICK_COUNT += 1; // increment click count

      // skip and wait for timeout in order to detect double click
      if (this.CLICK_TIMER) {
        return;
      }

      this.CLICK_TIMER = setTimeout(() => {
        if (1 === this.CLICK_COUNT && !this.isTable && !this.isGroup) {
          this.select();
        }
        if (1 === this.CLICK_COUNT && this.isGroup) {
          this.expandCollapse();
        }
        if (2 === this.CLICK_COUNT && !this.isTable) {
          this.maybeZoomToLayer(this.layerstree)
        }
        this.CLICK_COUNT = 0;
        this.CLICK_TIMER = null;
      }, 300);
    },

    removeExternalLayer(name) {
      GUI.removeExternalLayer(name);
    },

    /**
     * @param evt
     * 
     * @fires GUI~context-menu since 4.1.0
     * 
     * @since 3.10.0
     */
    showContextMenu(evt) {
      GUI.emit('context-menu', evt, this.layerstree);
    },

    /**
     * @since 4.1.0
     */
    showLegendPanel() {
      GUI.showLegendPanel();
    },

    /**
     * set external legend url
     * 
     * @since 4.1.0
     */
    async setWmsSourceLayerLegendUrl() {
      if (!this.legend_tree.url) {
        this.legend_tree.loading = true;
        await this.$nextTick();
        this.legend_tree.url = getCatalogLayerById(this.layerstree.id).getLegendUrl({
          ...window.initConfig?.layout?.legend,
          width:  16,
          height: 16,
        });
      }
    },

    /**
     * @since 4.1.0
     */
    toggleCategory(index) {
      this.legend_categories[index].checked = !this.legend_categories[index].checked;
      ApplicationState.map_theme.theme      = null; // @since 4.0.7 set map_theme null on ckick on category

      //emit chang layer on map to refresh tiles
      getCatalogLayerById(this.layerstree.id).change();
      
      if ('tab' === this.legendplace) {
        this.layerstree.legend.change = true;
      } else if (this.legend_categories[index].checked && this.mapReady) {
        this.setCategories(false);
      }

    },

    /**
     * @since 4.1.0
     */
    setError() {
      this.legend_tree.error   = true;
      this.legend_tree.loading = false;
    },

    /**
     * @since 4.1.0
     */
    async urlLoaded() {
      this.legend_tree.loading = false;
    },

    /**
     * Handle changing style of layer legend
     *
     * @since 4.1.0
     */
    async onLayerChange(opts = {}) {
      if (this.is_external_wms) {
        return;
      }

      this.loading_legend = true;

      try {
        await this.setCategories(true);
        this.currentstyle = opts.style;                                // Set current style.
        if (this.dynamic) {    
          await this.setCategories(false);                           // toggle categories.
        }
      } catch(e) {
        console.warn('Error while changing layer style', e)
      }

      this.loading_legend = false;
    },

    /**
     * @param { boolean } all true = no bbox no filter (just all referred to)
     * 
     * @since 4.1.0
     */
    async setCategories(all = false) {
      try {
        const projectLayer = getCatalogLayerById(this.layerstree.id);
        const categories   = projectLayer.getCategories();

        if (all && categories) { // check if exist current layer categories
          this.legend_categories = categories;
        } else {
          const { nodes = [] } = await XHR.get({
            url: projectLayer.getLegendUrl(
              window.initConfig?.layout?.legend,
              {
                categories: true,
                format:     'application/json', // request format (icon and label of each category)
                all,
              }
            )
          });
          if (all) { // case of all categories
            const projectLayer = getCatalogLayerById(this.layerstree.id);
            const categories = [];
            nodes.forEach(({ icon, title, ruleKey, checked, symbols = [] }) => {
              if (icon) {
                // just one category is set (take care of `checked` and `ruleKey`).
                categories.push({ icon, title, ruleKey, checked, disabled: false });
              } else {
                // there are more that one category (`symbols` array is set).
                symbols.forEach(s => {
                  s._checked = s.checked;
                  s.disabled = false;
                  categories.push(s);
                });
              }
            });
            projectLayer.setCategories(categories);
            this.legend_categories = categories;
          } else {
            // case to update current categories
            if (nodes.length > 0) {
              nodes.forEach(({ icon, title, symbols = [] }) => {
                if (icon) {
                  symbols = [{ icon, title }];
                }
                this.legend_categories.forEach(c  => {
                  const findSymbol  = symbols.find(s => s.icon === c.icon && s.title === c.title);
                  const disabled    = undefined === c.checked || c.checked;
                  c.disabled        = disabled && undefined === findSymbol;
                  //@since 4.0.x In case of icon change base on map. Check icon in case of same title
                  c.icon            = (symbols.find(s => s.title === c.title && s.icon !== c.icon) || { icon: c.icon }).icon;
                });
              })
            } else {
              this.legend_categories.forEach(c => c.disabled = (undefined === c.checked) || c.checked);
            }
          }
        }
      } catch(e) {
        console.warn(e);
        this.setError();
      }
    },

    /**
     * @since 4.1.0
     */
    async onLegendChange() {
      this.mapReady = true;
      if (
        this.layerstree.visible
        && !this.is_external_wms
        && ('toc' === this.legendplace || this.layerstree.categories)
      ) {
        await this.setCategories(false);
      }
    },

    /**
     * @returns {Promise<void>}
     *
     * @listens map~change-map-legend-params
     *
     * @since 4.1.0
     */
    async initLegend() {
      await this.setCategories(true);
      if (this.dynamic) {
        await this.setCategories(false);
        GUI.on('change-map-legend-params', this.onLegendChange);
      }
      this.initialize = true;
    },

  },

  /**
   * Inizialize layer (disable, visible etc..)
   */
  created() {
    this.CLICK_COUNT = 0;    // count click events
    this.CLICK_TIMER = null; // timeoutID return by setTimeout Function

    if (this.isGroup && !this.layerstree.checked) {
      this.onGroupChecked(this.layerstree);
    }
    if (this.isGroup && !this.root && this.parent_mutually_exclusive && !this.layerstree.mutually_exclusive) {
      this.layerstree.nodes.forEach(node => { node.id && (node.uncheckable = true); })
    }
  },

  beforeDestroy() {
    this.CLICK_COUNT = 0;
    this.CLICK_TIMER = null;
  },

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.layerstree.toc)?_c('li',{staticClass:"tree-item",class:{
    selected:             _vm.layerstree.selected,
    disabled:             _vm.isDisabled,
    group:                _vm.isGroup,
    table:                _vm.isTable,
    external:             _vm.layerstree.external,
    'mutually-exclusive': _vm.parent_mutually_exclusive
  },attrs:{"tabindex":"0","role":"button"},on:{"contextmenu":function($event){$event.preventDefault();$event.stopPropagation();return _vm.showContextMenu.apply(null, arguments)},"click":function($event){$event.stopPropagation();return _vm.onTreeItemClick.apply(null, arguments)},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();return _vm.onTreeItemClick.apply(null, arguments)}}},[(!_vm.isTable && !_vm.isGroup && _vm.layerstree.external && _vm.layerstree.removable)?_c('button',{attrs:{"type":"button","title":"Remove"},on:{"click":function($event){$event.stopPropagation();return _vm.removeExternalLayer(_vm.layerstree.name, _vm.layerstree._type)}}},[_c('i',{staticClass:"fas fa-trash",staticStyle:{"color":"red"},attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"tree-toggler",attrs:{"type":"button","hidden":!(_vm.isGroup || (!_vm.isTable && ('toc' === _vm.legend_position || _vm.layerstree.categories)) && !_vm.layerstree.hidden)},on:{"click":function($event){$event.stopPropagation();return _vm.expandCollapse.apply(null, arguments)}}},[_c('i',{class:_vm.layerstree.expanded && (_vm.isGroup || _vm.layerstree.visible) ? 'fas fa-caret-down' : 'fas fa-caret-right',attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{attrs:{"hidden":""}},[_vm._v(_vm._s(_vm.$t('Enlarge / Reduce')))])]),_vm._v(" "),(_vm.isGroup || !_vm.isTable)?_c('input',{directives:[{name:"show",rawName:"v-show",value:(_vm.isGroup || !_vm.layerstree.hidden),expression:"isGroup || !layerstree.hidden"},{name:"model",rawName:"v-model",value:(_vm.layerstree.checked),expression:"layerstree.checked"}],attrs:{"type":"checkbox","role":"button","aria-label":"Show/Hide"},domProps:{"checked":Array.isArray(_vm.layerstree.checked)?_vm._i(_vm.layerstree.checked,null)>-1:(_vm.layerstree.checked)},on:{"click":function($event){$event.stopPropagation();return _vm.toggle()},"change":function($event){var $$a=_vm.layerstree.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.layerstree, "checked", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.layerstree, "checked", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.layerstree, "checked", $$c)}}}}):_vm._e(),_vm._v(" "),(_vm.isTable)?_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.layerstree.hidden),expression:"!layerstree.hidden"}],staticClass:"fas fa-table",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(_vm.isGroup && !_vm.layerstree.root)?_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.layerstree.hidden),expression:"!layerstree.hidden"}],staticClass:"fas fa-layer-group",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(!_vm.isTable && !_vm.isGroup && _vm.layerstree.external && 'vector' === _vm.layerstree._type)?_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.layerstree.hidden),expression:"!layerstree.hidden"}],staticClass:"fas fa-draw-polygon",staticStyle:{"color":"#fff"},attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(!_vm.isTable && !_vm.isGroup && _vm.layerstree.external && 'vector' !== _vm.layerstree._type)?_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.layerstree.hidden),expression:"!layerstree.hidden"}],staticClass:"far fa-image",staticStyle:{"color":"#fff"},attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),((!_vm.layerstree.hidden || _vm.isGroup) && !_vm.isGroup && !_vm.layerstree.external && null !== _vm.layerstree.filter.current)?_c('button',{staticClass:"action-button",staticStyle:{"box-shadow":"unset"},attrs:{"type":"button","data-i18n-title":_vm.layerstree.filter.current.name,"data-placement":"top","data-i18n-raw":""},on:{"click":function($event){$event.stopPropagation();return _vm.removeFilter.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-filter",staticStyle:{"color":"red"},attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.layerstree.hidden || _vm.isGroup),expression:"!layerstree.hidden || isGroup"}],staticClass:"tree-node-title",attrs:{"data-i18n-title":_vm.has_scale_visibility_toolip ? ("minscale:" + (_vm.layerstree.minscale) + " - maxscale:" + (_vm.layerstree.maxscale)) : '',"data-placement":"top","data-i18n-raw":""}},[_vm._v("\n    "+_vm._s(_vm.layerstree.title)+" "),(!_vm.isGroup && _vm.has_feature_count)?_c('b',[_vm._v(" ["+_vm._s(_vm.getFeatureCount)+"] ")]):_vm._e()]),_vm._v(" "),((!_vm.layerstree.hidden || _vm.isGroup) && !_vm.isGroup && _vm.layerstree.selection && _vm.layerstree.selection.active)?_c('button',{staticClass:"action-button",attrs:{"type":"button","title":"Clear Selection","data-placement":"left"},on:{"click":function($event){$event.stopPropagation();return _vm.clearSelection.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-broom",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(  !_vm.isGroup  //is not a group (layer)
                        && !_vm.layerstree.external // in not an external layer
                        && !_vm.layerstree.hidden  //is not hidden layer
                        && !_vm.layerstree.filter.pagination //has no pagination
                        && (
                            (_vm.layerstree.filter && _vm.layerstree.filter.current && _vm.layerstree.filter.current.name) //has current filter set from stored filter
                            || (_vm.layerstree.selection && _vm.layerstree.selection.active) // has a selection active
                          ))?_c('button',{staticClass:"action-button",class:_vm.layerstree.filter.active ? 'active' : '',attrs:{"type":"button","title":"Enable/Disable filter","data-placement":"left"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleFilter.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-filter",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),((!_vm.layerstree.hidden || _vm.isGroup) && !_vm.isGroup && _vm.layerstree.selection && _vm.logged && !_vm.layerstree.external && _vm.layerstree.selection.active && _vm.layerstree.filter.active)?_c('button',{staticClass:"action-button",attrs:{"type":"button","title":"Save Filter","data-placement":"left"},on:{"click":function($event){$event.stopPropagation();return _vm.saveFilter(_vm.layerstree)}}},[_c('i',{staticClass:"far fa-save",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.layerstree.root)?_c('button',{attrs:{"type":"button","data-placement":"left","title":"legend"},on:{"click":function($event){$event.stopPropagation();return _vm.showLegendPanel.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-list",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(!_vm.isGroup)?_c('button',{staticClass:"toggle-context-menu",attrs:{"type":"button","data-placement":"left","title":"Open menu"},on:{"click":function($event){$event.stopPropagation();return _vm.showContextMenu.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-ellipsis-v",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.has_legend)?_c('figure',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_legend),expression:"show_legend"},{name:"disabled",rawName:"v-disabled",value:(!_vm.is_external_wms && _vm.loading_legend),expression:"!is_external_wms && loading_legend"}],staticClass:"tree-legend",attrs:{"role":"presentation"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading_legend || _vm.legend_tree.loading),expression:"loading_legend || legend_tree.loading"}],staticClass:"bar-loader"}),_vm._v(" "),(_vm.is_external_wms)?_c('img',{attrs:{"loading":"lazy","src":_vm.legend_tree.url,"alt":""},on:{"loaderror":function($event){return _vm.setError()},"load":function($event){return _vm.urlLoaded()}}}):_vm._l((_vm.legend_categories),function(category,index){return _c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(category.disabled),expression:"category.disabled"}],staticStyle:{"display":"flex","align-items":"flex-start","width":"100%"},on:{"contextmenu":function($event){$event.preventDefault();$event.stopPropagation();}}},[(category.ruleKey)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(category.checked),expression:"category.checked"}],attrs:{"type":"checkbox","role":"button","aria-label":"Show/Hide"},domProps:{"checked":Array.isArray(category.checked)?_vm._i(category.checked,null)>-1:(category.checked)},on:{"click":function($event){$event.stopPropagation();return _vm.toggleCategory(index)},"change":function($event){var $$a=category.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(category, "checked", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(category, "checked", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(category, "checked", $$c)}}}}):_vm._e(),_vm._v(" "),(('toc' === _vm.legendplace))?_c('img',{staticStyle:{"margin":"4px 4px 0 5px"},attrs:{"src":category.icon && ("data:image/png;base64," + (category.icon)),"alt":""},on:{"error":function($event){return _vm.setError()},"load":function($event){return _vm.urlLoaded()}}}):_vm._e(),_vm._v(" "),(('tab' === _vm.legendplace && category.ruleKey) || ('toc' === _vm.legendplace))?_c('span',{staticClass:"g3w-long-text",staticStyle:{"padding-left":"3px"}},[_c('span',[_vm._v(_vm._s(category.title))]),_vm._v(" "),(_vm.has_feature_count && undefined !== category.ruleKey)?_c('b',[_vm._v(" ["+_vm._s(_vm.layerstree.featurecount[category.ruleKey])+"] ")]):_vm._e()]):_vm._e()])})],2):_vm._e(),_vm._v(" "),(_vm.isGroup)?_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.layerstree.expanded),expression:"layerstree.expanded"}],staticClass:"group"},_vm._l((_vm.layerstree.nodes),function(_layerstree){return _c('catalog-tree',{key:_layerstree.id || _layerstree.groupId,attrs:{"root":false,"legendplace":_vm.legendplace,"layerstree":_layerstree,"storeid":_vm.storeid,"parent":_vm.layerstree,"parent_mutually_exclusive":!!_vm.layerstree.mutually_exclusive}})}),1):_vm._e()]):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "CatalogTree.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__